import React from 'react';

import CTAFullWidth from './CTAFullWidth';
import CTAWithImage from './CTAWithImage';


const CTAContent = ({ entity, viewMode, display, ...props }) => {
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  switch (display) {

    case 'noimage': {
      return <CTAFullWidth id={paragraphKey} entity={entity} {...props} />;
    }

    case 'split': {
      return <CTAWithImage id={paragraphKey} entity={entity} {...props} />;
    }

    default: {
      return <CTAFullWidth id={paragraphKey} entity={entity} {...props} />;
    }
  }
};

export default CTAContent;
